import axios from 'axios'
import qs from 'qs'
export default {
  //1 文件上传
  fileUpload(params, config) {
    return axios.post('/fileUpload', params, config)
  },
  //2 文件列表查询
  selectFileList(params) {
    return axios.post('/selectFileList', qs.stringify(params))
  },
  //3 文件删除
  deleteFile(params) {
    return axios.post('/deleteFile', qs.stringify(params))
  },
  //4 导入基准数据
  textSip(params) {
    return axios.post('/textSip', qs.stringify(params))
  },
  //5 导入时延数据
  textCscf(params) {
    return axios.post('/textCscf', qs.stringify(params))
  },
  //6 筛选基准数据
  sip(params) {
    return axios.post('/sip', qs.stringify(params))
  },
  //7 筛选时延数据
  cscf(params) {
    return axios.post('/cscf', qs.stringify(params))
  },
  //8 开始计算
  jscscf(params) {
    return axios.post('/jscscf', qs.stringify(params))
  },
  //9 清除基础数据库
  clearFront(params) {
    return axios.post('/clearFront', qs.stringify(params))
  },
  //10 清除时延数据库
  clearLater(params) {
    return axios.post('/clearLater', qs.stringify(params))
  },
  //11 重命名
  updateProjectName(params) {
    return axios.post('/updateProjectName', qs.stringify(params))
  },
  //12 保存计算结果
  saveRecord(params) {
    // return axios.post('/saveRecord', params);
    return axios.post('/saveRecord', qs.stringify(params))
  },
  //13 保存计算结果全查
  SelectRecord(params) {
    return axios.post('/SelectRecord', qs.stringify(params))
  },
  //14 查询保存的计算结果的详情
  SelectDetails(params) {
    return axios.post('/SelectDetails', qs.stringify(params))
  },
  // 15 导出全部文件
  downloadFile(params) {
    return axios.get('/getSalesdownloadSalesFile', {
      params
    })
  },
  // 16 导出单个文件
  downloadFile(params) {
    return axios.get('/downloadone', {
      params
    })
  },
  //17 查状态
  statu(params) {
    return axios.post('/statu', qs.stringify(params))
  },
  //18 进度条
  progress(params) {
    return axios.post('/progress', qs.stringify(params))
  },
  //19 文件下载
  fileDownload(params) {
    return axios.post('/fileDownload', qs.stringify(params))
  },
  //20 门限值的筛选
  selectLimit(params) {
    return axios.post('/selectLimit', qs.stringify(params))
  },
  //21 查看重复数据
  selectError(params) {
    return axios.post('/selectError', qs.stringify(params))
  }
}



// WEBPACK FOOTER //
// ./src/api/home.js